// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"40c4431c","238":"21188b29","686":"e811e47d"}[chunkId] + ".chunk.js";
};